import { format } from 'date-fns';

export const formatDate = (timestamp: string | undefined) => {
  if (!timestamp || timestamp === '') return '';
  return format(new Date(timestamp), 'yyyy/MM/d  hh:mm a');
};
